/* import __COLOCATED_TEMPLATE__ from './article-group-filter-option.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();